import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/utils';
import { Loader } from 'lucide-react';

const buttonVariants = cva('flex justify-center', {});

const Button = React.forwardRef(({ className, variant, size, asChild = false, loading, children, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp className={cn(buttonVariants({ className }))} disabled={loading} ref={ref} {...props}>
      {loading && <Loader className="animate-spin mr-2 inline-block" />}
      {children}
    </Comp>
  );
});
Button.displayName = 'Button';

export { Button, buttonVariants };
